import { IBaseMappedItem } from '@app/logic/base/interfaces/i.base-mapped-item';
import { IDtoBase } from '@classictechsolutions/hubapi-transpiled-enums';

export class MappedItemUtils {
    public static isMappedItem(item: IBaseMappedItem<any, any, any> | IDtoBase<any>): boolean {
        return '$id' in item;
    }
}
